import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseNavigationalHeaderTokens = {
    ICON_WRAPPER_SIZE: 24,
};
//
// Helpers
//
export const CFBaseNavigationalHeaderHelpers = {
    textWrapperAlignment: ({ hasLeftButton, hasRightButton, }) => {
        if (hasLeftButton && hasRightButton) {
            return css `
        align-items: center;
        text-align: center;
      `;
        }
        return css `
      align-items: flex-start;
      text-align: left;
    `;
    },
};
//
// Element Styles
//
export const CFBaseNavigationalHeaderStyles = {
    IconWrapper: css `
    width: ${CFBaseNavigationalHeaderTokens.ICON_WRAPPER_SIZE}px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  `,
    Root: css `
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: ${CFTokens.SPACER.E}px;
  `,
    RootWithGap: css `
    gap: ${CFTokens.SPACER.LG};
  `,
    TextWrapper: css `
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    ${CFBaseNavigationalHeaderHelpers.textWrapperAlignment};
  `,
};
